import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { Service } from '../services';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { GlobalService } from '../global.service';
import { Subscription } from "rxjs";
import { AngularFireAnalytics } from '@angular/fire/analytics';
@Component({
  selector: 'app-paymenthistory',
  templateUrl: './paymenthistory.component.html',
  styleUrls: ['./paymenthistory.component.sass']
})
export class PaymentHistoryComponent implements OnInit {
  public tabActive = 'Factura y Pago';
  public empleados = [];
  public selectBan;
  public banlist;
  public selectYear;
  public year;
  public yearList = [];
  public invoicesHistory;
  public firstDate;
  public lastDate;
  public companyName;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public currentList;
  loadObserver: Subscription;
  public token: string = sessionStorage.getItem("token");
  constructor(private router: Router, public appComponent: AppComponent, private services: Service, private loadingScreenService: LoadingScreenService, public global:GlobalService, public AngularFireAnalytics:AngularFireAnalytics) {
    this.AngularFireAnalytics.setCurrentScreen("Historial de pagos");
    this.AngularFireAnalytics.logEvent("Historial de pagos-Screenview");
  }
  ngOnInit() {
    this.global.validateSession();
    if (this.global.sessionReview() == true) {
      this.banlist = JSON.parse(atob(sessionStorage.getItem("AccountList")));
      this.year = new Date().getFullYear();
      this.selectBan = atob(sessionStorage.getItem("selectBan"));
      this.selectYear = this.year;
      this.currentYear();
      this.updateBillsPayment();
      this.companyName = atob(sessionStorage.getItem("companyName"));
      this.loadObserver = this.global.loadObserver.subscribe((value: number) => {
        this.dataLoading(value)
      });
    }
  }
  dataLoading(sw) {
    this.updateBillsPaymentChange();
  }
  refreshDataTo(event: Event) {
    if(this.global.validateSession()===true){
      let index = parseInt(event.target["selectedIndex"]);
      let ban = this.currentList[index].account;
      sessionStorage.setItem("selectBan", btoa(ban));
      this.initializeData();
    }
  }
  initializeData() {
    this.global.refreshDataTo(this.token);
  }
  updateBillsPaymentChange() {
    this.global.validateSession();
    sessionStorage.setItem("selectBan", btoa(this.selectBan));
    this.updateBillsPayment();
  }
  currentYear() {
    this.year = new Date();
    var anio = this.year.getFullYear();
    for (var i = 0; i < 2; i++) {
      this.yearList[i] = anio - i;
    }
    this.selectYear = anio;
  }
  dateInit() {
    if (this.invoicesHistory.length > 0) {
      for (var i = 0; i < this.invoicesHistory.length; i++) {
        this.firstDate = this.invoicesHistory[0].Fecha;
        if (i === this.invoicesHistory.length - 1) {
          this.lastDate = this.invoicesHistory[i].Fecha;
        }
      }
    }
  }
  updateBillsPayment() {
    this.loadingScreenService.startLoading();
    this.services.getPaymentHistory(sessionStorage.getItem("token"), this.selectBan, this.selectYear).subscribe(data => {
      if (data.HasError == false) {
        this.loadingScreenService.stopLoading();
        sessionStorage.setItem("getPaymentHistory", btoa(JSON.stringify(data)));
        this.invoicesHistory = JSON.parse(atob(sessionStorage.getItem("getPaymentHistory"))).PaymentHistory;
        this.dateInit();
      }
      else {
        this.loadingScreenService.stopLoading();
        this.global.notif(data.ErrorDesc);
      }
    });
  }
}
